var _mask, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgress4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_381_492",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.6022 1.91059e-08 13.1809 0.384974 14.6033 1.12251C16.0256 1.86004 17.2499 2.92853 18.1731 4.23802C19.0963 5.54751 19.6913 7.05965 19.9081 8.64711C20.1248 10.2346 19.957 11.8509 19.4186 13.3599L10 10L10 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.6022 1.91059e-08 13.1809 0.384974 14.6033 1.12251C16.0256 1.86004 17.2499 2.92853 18.1731 4.23802C19.0963 5.54751 19.6913 7.05965 19.9081 8.64711C20.1248 10.2346 19.957 11.8509 19.4186 13.3599L10 10L10 0Z",
    fill: "#09702B",
    stroke: "#09702B",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_381_492)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    transform: "rotate(-90 10 10)",
    stroke: "#09702B",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress4);
export default __webpack_public_path__ + "static/media/progress4.2146e1b1abe3bf82641123ce14bbed39.svg";
export { ForwardRef as ReactComponent };